import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

export const useActivityInfo = (
  corporateId: string | number,
  loId?: string | number,
): { activityTitle?: string } => {
  const url =
    corporateId && loId
      ? `${ServicesURL.getActivities.replace(
          ":idCorporate",
          String(corporateId),
        )}/${loId}`
      : null;

  const { data } = useSWR(url, (u: string) => fetcher<any>(u, MethodType.GET));

  return {
    activityTitle: typeof data?.title === "string" ? data.title : undefined,
  };
};
